import React, { useRef, useEffect, useCallback } from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import { getMomentDate } from 'utils/date';
import { reformatDate } from './utils';
import classes from './DatePicker.module.scss';

const DatePicker = ({
  className,
  onChange,
  form,
  customValidateName,
  value,
  ...other
}) => {
  const tValue =
    !!value && typeof value === 'string' && value.includes('*') ? '' : value;

  const inputRef = useRef(null);

  const reformatDateHandler = useCallback(
    e => reformatDate(form, customValidateName, other.name)(e),
    [form, customValidateName, other.name]
  );

  useEffect(() => {
    const input = inputRef.current && inputRef.current.input;
    if (input && !other.picker) {
      input.addEventListener('keypress', reformatDateHandler);
      input.maxLength = 10;
    }

    return () => {
      if (input && !other.picker) {
        input.removeEventListener('keypress', reformatDateHandler);
      }
    };
  }, [reformatDateHandler, other.picker]);

  const handleChange = (date, dateString) => {
    if (onChange) onChange(date, dateString);
    if (form && dateString) {
      form.setFieldsValue({
        [customValidateName || other.name]: getMomentDate(dateString),
      });
    }
    if (date && form) {
      form.setFields([
        {
          name: customValidateName || other.name,
          errors: null,
        },
      ]);
    }
  };

  return (
    <AntdDatePicker
      {...other}
      value={tValue}
      onChange={handleChange}
      className={classes.wrapper + ' ' + className}
      ref={inputRef}
    />
  );
};

export default DatePicker;
